export default __webpack_public_path__ + "static/media/Animations_Bar9.f36795f9.svg";